import { useState } from "react";
import CustomCard from "./Card";
import ForgetPassForm from "./forgetPassForm";

export default function ForgetPassword() {
  const [level, setLevel] = useState(1);
  return (
    <CustomCard
      title={
        level === 1
          ? "رمز عبور خود را فراموش کرده اید ؟!"
          : level === 2
            ? "وارد کردن کد تأیید"
            : "رمز عبور جدید"
      }
      subTitle={
        level === 1
          ? "برای بازیابی رمز، کد ملی خود را وارد نمایید."
          : level === 2
            ? "کد به شماره تلفن شما ارسال شد."
            : "لطفا رمز عبور جدید خود را تعیین کنید."
      }
    >
      <ForgetPassForm level={level} setLevel={setLevel} />
    </CustomCard>
  );
}
